module.exports = __webpack_public_path__ + "media/bootstrap-icons/record2-fill-36b0cb2a.svg";